import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import './Detail-View-Preview.scss';
import {
  allAmenitiesSelector,
  allRestaurantSelector,
  allRoomTypesSelector,
  allSpaInfoSelector,
} from '../../../../layouts/property/propertySlice';
import { ASSET_URL } from '../../../../env/Configurations';
import { offerSelector } from '../../../../layouts/cms/cmsSlice';

const DetailViewPreview = (props) => {
  const { config } = props;
  const originalRestaurant = useSelector(allRestaurantSelector);
  const originalSpa = useSelector(allSpaInfoSelector);
  const originalAmenities = useSelector(allAmenitiesSelector);
  const originalRooms = useSelector(allRoomTypesSelector);
  const originalOffers = useSelector(offerSelector);
  const [selectedModule, setSelectedModule] = useState({});
  useEffect(() => {
    switch (config.hotelModule) {
      case 'AMENITY':
        setSelectedModule(originalAmenities.find((item) => item.id === config.hotelModuleId));
        break;
      case 'RESTAURANT':
        setSelectedModule(originalRestaurant.find((item) => item.id === config.hotelModuleId));
        break;
      case 'ROOMS':
        setSelectedModule(originalRooms.find((item) => item.id === config.hotelModuleId));
        break;
      case 'WELLNESS':
        setSelectedModule(originalSpa.find((item) => item.id === config.hotelModuleId));
        break;
      case 'OFFERS':
        setSelectedModule(originalOffers.find((item) => item.id === config.hotelModuleId));
        break;
      default:
        setSelectedModule({});
        break;
    }
  }, [config]);

  return (
    <div className='ui-component-detail-view'>
      <div
        className='detail-view-image-container'
        style={
          config?.hotelModuleId && selectedModule?.images?.length
            ? {
                backgroundImage: 'url(' + ASSET_URL + selectedModule?.images[0]?.master + ')',
                backgroundSize: 'cover',
              }
            : {}
        }
      >
        {config.hotelModuleId === '' && <span>Image</span>}
      </div>
      <div className='m-2'>
        {config.hotelModuleId === '' ? 'Sub Module Title' : selectedModule?.name}
      </div>
      <div className='m-2 detail-view-description'>
        {config.hotelModuleId === '' ? 'Description of the module' : selectedModule?.description}
      </div>
      {config.hotelModule === 'RESTAURANT' && (
        <div className='my-3 d-flex justify-content-evenly'>
          {selectedModule?.menuStatus === 'Active' && (
            <button className='menu-btn rounded px-4'>{selectedModule?.ctaTitle || 'MENU'}</button>
          )}
          {selectedModule?.cta?.status === 'Active' && (
            <button className='menu-btn rounded px-4'>{selectedModule?.cta?.ctaTitle}</button>
          )}
        </div>
      )}
    </div>
  );
};

export default DetailViewPreview;
